
<div>
  @for (q of sqlQueries(); track $index)
  {
    <div class="query-plan-view-prop-grid">
      <div>
        <label>Data Source</label>
        <span></span>
      </div>
      <div>
        <label>Type</label>
        <span>{{q.dataSource.type}}</span>
      </div>
      @if (q.dataSource.type == 'sqlDb') {
        <div>
          <label>Provider</label>
          <span>{{$any(q.dataSource).kind}}</span>
        </div>
        @if ($any(q.dataSource).target?.server) {
          <div>
            <label>Target</label>
            <span>{{$any(q.dataSource).target?.server}}/{{$any(q.dataSource).target?.database}}</span>
          </div>
        }
      }
    </div>

    <div>
      @for (s of q.sql; track $index) {
      @for (c of s.commands; track $index) {
        <div class="query-plan-view-prop-grid">
          <div>
            <label>Query</label>
            <span></span>
          </div>
          <div>
            <label>Type</label>
            <span>{{CommandType[c.type]}}</span>
          </div>
          <div>
            <label>Behavior</label>
            <span>{{CommandBehavior[c.type]}}</span>
          </div>

          @if (c.parameters?.length) {
            <div>
              <label>Parameters</label>
              <div class="query-plan-view-prop-grid">
                @for (p of c.parameters; track $index) {
                  <div>
                    <label>Name</label>
                    <span>{{p.name}}</span>
                  </div>
                  <div>
                    <label>Data Type</label>
                    <span>{{$any(p).dataType.typeInfo.name}}</span>
                  </div>
                  <div>
                    <label>Value</label>
                    <span>{{p.value}}</span>
                  </div>
                }
              </div>
            </div>
          }
          @if (c.text) {
            <div>
              <label>Query</label>
              <code>{{c.text}}</code>
            </div>
          }
          @if (c.debugDisplay) {
            <div>
              <label>Debug Display</label>
              <code>{{c.debugDisplay}}</code>
            </div>
          }
        </div>
      }
      }
    </div>
  }
</div>